import { AdjacentType, BranchingQueryDefinition, getItemTypeToGroupNestedDescendingQueryDef, getParentEdgeTypeId, } from '@iotv/datamodel-core';
import { getSimpleSubjectQuery, getSimpleBranchingQuery } from '@iotv/datamodel-core';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { getGroupForEntity } from '../../helpers/queryHelpers';
const regionToPartnerQuery = new BranchingQueryDefinition({
    id: 'regionToPartner',
    path: [
        {
            objectTypeId: 'Partner',
            edgeTypeId: getParentEdgeTypeId('Partner', 'Region'),
            adjacencyType: AdjacentType.CHILD,
        },
    ],
    subQueries: [],
});
const regionToParentRegion = new BranchingQueryDefinition({
    id: 'regionToRegion',
    path: [
        {
            objectTypeId: 'Region',
            edgeTypeId: getParentEdgeTypeId('Region', 'Region'),
            adjacencyType: AdjacentType.PARENT,
        },
    ],
    subQueries: [regionToPartnerQuery],
});
/** Gets all partners for a particular region
 * @param region - The region to start the query from
 * @returns - An err data where data is a node edge mapper containing the region, all parent regions, and all partners connected to the region tree
 * */
export const getPartnersForRegion = async (region) => {
    const regionApex = getSimpleSubjectQuery('Region');
    regionApex.addSubQuery(regionToParentRegion);
    return await ConsumerDao.getGraphQueryRequestV2({ query: regionApex, contextObjects: [region] });
};
/** Gets all partners from a region and all partners connected to parents of the current region
 * @param region - The region to start the query from
 * @returns - An err data where data is a node edge mapper containing the region, all parent regions, and all partners connected to the region tree
 * */
export const getPartnersForAllRegionsAboveQuery = () => {
    const regionApex = getSimpleSubjectQuery('Region');
    regionApex.addSubQuery(regionToParentRegion);
    regionApex.addSubQuery(regionToPartnerQuery);
    return regionApex;
};
/** Gets all partners who have access to a specific group and parent groups
 * @remarks
 * Consider having this return a nem, if you need to know exactly who's connected to me and who's just connected to a parent group
 * @param group - The group to get partners for
 * @returns A list of partners that have access to this
 * */
export const getPartnersForGroup = async (group) => {
    const partnerQuery = getSimpleBranchingQuery('Group', 'Partner', AdjacentType.PARENT);
    const groupToGroup = getSimpleBranchingQuery('Group', 'Group', AdjacentType.PARENT);
    groupToGroup.addSubQuery(groupToGroup);
    groupToGroup.addSubQuery(partnerQuery);
    const groupSubject = getSimpleSubjectQuery('Group');
    groupSubject.addSubQuery(partnerQuery);
    let res = { err: null, data: null };
    const partner_res = await ConsumerDao.getGraphQueryRequestV2({ query: groupSubject, contextObjects: [group] });
    if (partner_res.err) {
        console.error(partner_res.err);
        res.err = partner_res.err;
        return res;
    }
    if (!partner_res.data) {
        const errMsg = 'Group<-Partner query returned no err but no data?';
        console.error(errMsg);
        res.err = new Error(errMsg);
        return res;
    }
    const partners = partner_res.data.getNodesOfType('Partner');
    res.data = partners;
    return res;
};
export const getPartnerUsersForEntityOrGroup = async (entityOrGroup) => {
    const partnerToUser = getItemTypeToGroupNestedDescendingQueryDef({
        includeSupportedTypeInstances: true,
        groupDefiningObjectTypeId: 'Partner',
        supportedType: 'User',
    });
    const groupToPartner = getSimpleBranchingQuery('Group', 'Partner', AdjacentType.PARENT);
    groupToPartner.addSubQuery(partnerToUser);
    const groupToGroup = getSimpleBranchingQuery('Group', 'Group', AdjacentType.PARENT);
    groupToGroup.addSubQuery(groupToGroup);
    groupToGroup.addSubQuery(groupToPartner);
    const groupApexQuery = getSimpleSubjectQuery('Group');
    groupApexQuery.addSubQuery(groupToGroup);
    groupApexQuery.addSubQuery(groupToPartner);
    // Get group if we've been given an entity
    let relevantGroup = entityOrGroup.type === 'Group' ? entityOrGroup : undefined;
    if (relevantGroup === undefined) {
        const parentGroupRes = await getGroupForEntity(entityOrGroup);
        if (!parentGroupRes.data) {
            return { partnerUsers: [], tree: null };
        }
        console.log('Partner Query Relevant Group', parentGroupRes);
        relevantGroup = parentGroupRes.data;
    }
    const user_res = await ConsumerDao.getGraphQueryRequestV2({ query: groupApexQuery, contextObjects: [relevantGroup] });
    console.log('getPartnerUsersForEntityOrGroup', user_res);
    if (user_res.err) {
        console.error(user_res.err.message);
        return { partnerUsers: [], tree: null };
    }
    return { partnerUsers: user_res.data?.getNodesOfType('User'), tree: user_res.data };
};
